import { useRedirectLink } from '../../submodules/web-shared/modules/Permissions/redirect-links-hook';

const App = () => {
  const { link, pack } = useRedirectLink();
  window.location.replace(`/${pack}/${link}`);
  return null;
};

export default App;